module.exports = __webpack_public_path__ + "img/oneTitleLine.c1150350.png";